import { compact } from 'lodash/fp'
import videoConsentSection from '../videoConsentSection'
import { isPayerNeeded } from '../selectors'
import { get } from 'lodash/fp'

export const videoConsent = (app, props = {}) => {
  const hasPayer = isPayerNeeded(app)
  const signedDocuments = get('signedDocs', app)

  //  Make sure documents are signed before showing video consent
  const { insured = [], payer = [], advisor = [], acknowledge = [] } = signedDocuments || {}
  // length should be more than 0
  const signed = insured.length > 0 && advisor.length > 0 && acknowledge.length > 0 && (!hasPayer || payer.length > 0)

  return Object.assign(
    {},
    {
      id: 'video-consent',
      prefix: 'video-consent',
      title: 'บันทึกภาพ',
      label: 'บันทึกภาพ',
      sections: compact([videoConsentSection()]),
      disabled: !signed,
      remoteSection: true,
    },
    props
  )
}
